import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "StepSuccess",
  "use": "StepSuccess-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"StepSuccess\">\n<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#03ADEF\" />\n<path d=\"M18 23.586L14.707 20.293L13.293 21.707L18 26.414L27.707 16.707L26.293 15.293L18 23.586Z\" fill=\"white\" stroke=\"white\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol